import { render } from "./KalenderMode.vue?vue&type=template&id=2f9928f6"
import script from "./KalenderMode.vue?vue&type=script&lang=js"
export * from "./KalenderMode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__